import PropTypes from 'prop-types';
import React from 'react';
import { eventEndPointBaseUrl } from '../../../Includes/Constants/events';
import ArrowSVG from '../../../SVGs/ArrowSVG/ArrowSVG';

import './DropdownMenu.scss';

export default class DropdownMenu extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isDropdownOpen: false,
        };
    }

    static propTypes = {
        /**
         * list of filter options displayed as dropdown menu
         */
        dropdownMenu: PropTypes.array,
        /**
         * svg image component
         */
        placeHolderIcon: PropTypes.node,
        /**
         * text displayed as placeholder or the filter selected
         */
        displayText: PropTypes.string,
        /**
         * function that build the url with query params
         */
        buildQueryUrl: PropTypes.func,
        /**
         * array of current query params
         */
        currentParams: PropTypes.array,
        /**
         * current eventStatus being selected
         */
        currentEventStatus: PropTypes.string,
        /**
         * params for "All" filter option
         */
        paramsForAll: PropTypes.array,
        /**
         * text displayed on "All" filter options
         */
        displayTextForAll: PropTypes.string,
    };

    static defaultProps = {
        placeHolderIcon: null,
        displayText: '',
        dropdownMenu: [],
        currentParams: [],
        buildQueryUrl: () => {},
        currentEventStatus: '',
        paramsForAll: [],
        displayTextForAll: '',
    };

    toggleDropdownMenu = () => {
        const { isDropdownOpen } = this.state;
        this.setState({
            isDropdownOpen: !isDropdownOpen,
        });
    };

    handleBlur = () => {
        /**
         * prevent hiding dropdown menu before clicking menu Item
         */
        setTimeout(() => {
            this.setState({
                isDropdownOpen: false,
            });
        }, 200);
    };

    buildEventsQueryUrl = (queryParams) => {
        const { currentEventStatus } = this.props;
        let queryUrl = eventEndPointBaseUrl;
        let isEventStatusIncluded = false;
        queryParams.forEach((param, index) => {
            const { queryName, queryValue } = param;
            const isLastParam = queryParams.length === index + 1;
            if (queryName === 'eventStatus') {
                isEventStatusIncluded = true;
            }
            queryUrl = queryUrl.concat(
                `${queryName}=${queryValue}${!isLastParam ? '&' : ''}`
            );
        });
        return isEventStatusIncluded
            ? queryUrl
            : queryUrl.concat(`&eventStatus=${currentEventStatus}`);
    };

    replaceCurrentQuery = (menuItem) => {
        const { currentParams } = this.props;
        const menuItemParam = menuItem.queryParams.map(
            (param) => param.queryName
        );
        const filteredCurrentParams = currentParams.filter(
            (currentParam) => !menuItemParam.includes(currentParam.queryName)
        );
        return filteredCurrentParams;
    };

    render() {
        const { isDropdownOpen } = this.state;
        const {
            displayText,
            placeHolderIcon,
            dropdownMenu,
            paramsForAll,
            displayTextForAll,
        } = this.props;
        return (
            <div className="component-Events-EventsFilterHeader-DropdownMenu">
                <div
                    className="dropdown-placeholder-wrapper"
                    tabIndex={0}
                    onClick={this.toggleDropdownMenu}
                    onBlur={this.handleBlur}
                >
                    {placeHolderIcon && placeHolderIcon}
                    <span className="dropdown-placeholder">{displayText}</span>
                    <ArrowSVG direction="down" />
                </div>
                <div className="dropdown-option-wrapper">
                    {isDropdownOpen && (
                        <React.Fragment>
                            <a
                                className="dropdown-option-item"
                                href={this.buildEventsQueryUrl([
                                    ...paramsForAll,
                                ])}
                            >
                                {displayTextForAll}
                            </a>
                            {dropdownMenu.map((menuItem, index) => {
                                const filteredCurrentParams = this.replaceCurrentQuery(
                                    menuItem
                                );
                                return (
                                    <a
                                        className="dropdown-option-item"
                                        key={`item-${index}`}
                                        href={this.buildEventsQueryUrl([
                                            ...filteredCurrentParams,
                                            ...menuItem.queryParams,
                                        ])}
                                    >
                                        {menuItem.text}
                                    </a>
                                );
                            })}
                        </React.Fragment>
                    )}
                </div>
            </div>
        );
    }
}
